import { AmendSidePanel } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/shared/AmendSidePanel';
import { connectAmendSidePanelFactory } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/shared/sidePanel.connect';
import { connect } from 'react-redux';
import { limitOrderAmendSelectors } from 'state/secondaryMarket/limit-order/amend/amend.selectors';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import { limitOrderKycSelectors } from 'state/secondaryMarket/limit-order/kyc/kyc.selectors';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';

export const { mapStateToProps, mapDispatchToProps } = connectAmendSidePanelFactory(
  limitOrderSelectors,
  limitOrderKycSelectors,
  limitOrderAmendSelectors,
  limitOrderThunks,
  limitOrderInputFormActions,
);

export const connectAmendLimitOrderSidePanel = connect(mapStateToProps, mapDispatchToProps);

export const ConnectedAmendLimitOrderTradeSidePanel = connectAmendLimitOrderSidePanel(AmendSidePanel);
